import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { COLUMNS } from "./columnTrans";
import Header from "../../layout/Header";
import { getSchemaList } from "../../../actions/auth";
import { schema } from "../campaigns/services";
import TransactionPaginated from "./TransactionPaginated";

function TransactionSchema() {
  const [formData, setFormData] = useState([]);
  const [response, setResponse] = useState([]);

  const [loader, setLoader] = useState(false);
  const updateData = () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let schemaName = localStorage.getItem("schemaName");
    schemaName = schemaName?.split(" ").join("");
    schema(token?.access_token, schemaName).then((res) => {
      setResponse(res?.data?.schema?.properties);
      setLoader(false);
    });
  };
  useEffect(() => {
    if (response) {
      const tempData = Object.keys(response)?.map((key) => {
        const field = response[key];
        return {
          ...field,
          fieldName: key,
          displayName: field.fielddisplayname,
          dataType: field.type,
          fielddatatype:
            field.fielddatatype === "Enumeration"
              ? field.enum?.join(", ")
              : field.fielddatatype,
          IsMobileField: field.IsMobileField === true ? "True" : "False",
          isuniqueidentifier:
            field.isuniqueidentifier === true ? "True" : "False",
          isrequired: field.isRequired === true ? "True" : "False",
          action:
            field.fielddisplayname === "Transaction Date" ||
            field.fielddisplayname === "Transaction type" ||
            field.fielddisplayname === "schemacode" ? (
              <span
                className="edit_btn"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#ccc",
                  cursor: "not-allowed",
                  pointerEvents: "none",
                }}
              >
                <i className="fa-solid fa-pen"></i>
              </span>
            ) : (
              <Link
                className="edit_btn"
                state={{ key, field }}
                to="/transactionSchema"
                style={{ display: "flex", justifyContent: "center" }}
                csvalue="Edit"
              >
                <i className="fa-solid fa-pen"></i>
                <div className="show_div">Edit</div>
              </Link>
            ),
          // isSignUp: field.isSignUp === true ?"True" : "False",
          // isSignUp: field.isSignUp === true ?"True" : "False",
        };
      });
      setFormData(tempData);
    }
  }, [response]);

  useEffect(() => {
    updateData();
  }, []);

  const downloadCSV = () => {
    const csvHeaders = [
      "Field Name",
      "Display Name",
      "Data Type",
      "Field Data Type",
      "Is Mobile Field",
      "Is Transaction Ident",
      "Is Required",
    ];

    const escapeCsvValue = (value) => {
      const stringValue = value === undefined || value === null ? "" : String(value);
      return `"${stringValue.replace(/"/g, '""')}"`;
    };

    const csvRows = formData.map((row) =>
      [
        row.fieldName,
        row.displayName,
        row.dataType,
        row.fielddatatype,
        row.IsMobileField,
        row.isuniqueidentifier,
        row.isrequired,
      ].map(escapeCsvValue)
    );

    const csvContent = [csvHeaders.map(escapeCsvValue), ...csvRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "transaction_schema.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Header name={"Transaction Schema"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="dashboard__heading">
                                <div className="dashboard__headingLeft">
                                    <div className="dashboard__headingContent">
                                        <Link to="/create-Transaction">
                                            <Button id="voucher" className="btn btn-primary btn-lg">
                                                Create Transaction Schema
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            <div className="dashboard__customersCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="voucher_details">Transaction Schema Details</h4>
                </div>
                <div className="dashboard__right">
                  <button className="btn btn-default" onClick={downloadCSV}>
                    <i
                      class="fa-solid fa-download"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Download
                  </button>
                </div>
              </div>
              <div className="dashboard__body">
                {" "}
                <TransactionPaginated
                  data={formData ? formData : []}
                  columns={COLUMNS}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TransactionSchema;
